import React from "react";
import workspaceTheme from "./workspaceTheme.module.css";

type Tone = "neutral" | "success" | "warning" | "error" | "info";

const inferTone = (value: string | null | undefined): Tone => {
  const normalized = (value || "").trim().toLowerCase();
  if (!normalized) {
    return "neutral";
  }

  if (["imported", "completed", "published", "ready", "active", "enabled"].includes(normalized)) {
    return "success";
  }
  if (["needs review", "completed with errors", "completed_with_errors", "warning"].includes(normalized)) {
    return "warning";
  }
  if (["failed", "unimportable", "withdrawn", "disabled", "error"].includes(normalized)) {
    return "error";
  }
  if (["importing", "running", "queued", "processing", "draft"].includes(normalized)) {
    return "info";
  }

  return "neutral";
};

const toneClassMap: Record<Tone, string> = {
  neutral: workspaceTheme.statusNeutral,
  success: workspaceTheme.statusSuccess,
  warning: workspaceTheme.statusWarning,
  error: workspaceTheme.statusError,
  info: workspaceTheme.statusInfo,
};

type Props = {
  label: string | null | undefined;
  tone?: Tone;
  className?: string;
};

export const WorkspaceStatusChip = ({ label, tone, className }: Props) => {
  const displayLabel = label || "Unknown";
  const nextTone = tone || inferTone(displayLabel);

  return (
    <span className={[workspaceTheme.statusChip, toneClassMap[nextTone], className].filter(Boolean).join(" ")}>
      {displayLabel}
    </span>
  );
};
